import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=cb109a2e"
import script from "./Confetti.vue?vue&type=script&lang=ts"
export * from "./Confetti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports